export async function login(username, password) {
  const res = await fetch("https://marsiweb.com/padelapi/api/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  if (!res.ok) throw new Error("Login incorrecto");
  return await res.json();
}
